<template>  
  <div>
    <q-card inline style="width: 300px; background-color: transparent;">
      <q-card-section>
        <div v-if="Entity.entity == 'MaintenanceGroup'"> 
          <div class="row">
            <div class="col-12">
            <q-btn class="space float-right" color="primary" :label="$t('global.AddNewGroup')" size="sm" @click="addDialog = true" />
            </div>
            <div class="col-12">
              
              <q-table
                style="background-color: transparent;"
                :title="$t('global.MaintenanceGroups')"
                :data="maintenanceGroupsOptions"
                :columns="columnsEvent"
                row-key="value"
                :dense=true
                selection="single"
                :selected.sync="selectedRowsGroup"
                :pagination.sync="pagination" 
                >

                <q-td slot="body-cell-Thumbnail" slot-scope="props" :props="props">
                  <img :src="'data:image/png;base64,' + props.value" @click="showPic(props.row.IdEvent)">
                </q-td>

              <template slot="top-selection" slot-scope="props" >
                <div class="q-table__title">{{$t('global.MaintenanceGroups')}}</div>
                <div>
                  <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editGroup()" />  
                  <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteGroup()" v-if="selectedRowsGroup[0].CanDelete == true" />
                </div>
              </template>
              </q-table>
            </div>
          </div>  
          <br>
        </div>
      
        <q-dialog v-model="editDialog" persistent>
          <q-card >
            <q-card-section class="row items-center">
              <span class="q-ml-sm q-table-title text-weight-bold">{{$t('global.EditGroupName')}}</span>
            </q-card-section>
            <q-card-section>
               <q-input v-model="editGroupName" :label="$t('global.Name')"/>
            </q-card-section>
            <q-card-actions align="right">
              <q-btn flat :label="$t('global.Cancel')" color="primary" v-close-popup />
              <q-btn flat :label="$t('global.Save')" @click="updateGroup()" color="primary" v-close-popup />
            </q-card-actions>
          </q-card>
        </q-dialog>
        <q-dialog v-model="addDialog" persistent>
          <q-card >
            <q-card-section class="row items-center">
              <span class="q-ml-sm q-table-title text-weight-bold">{{$t('global.AddNewGroup')}}</span>
            </q-card-section>
            <q-card-section>
               <q-input v-model="newGroup" :label="$t('global.Name')"/>
            </q-card-section>
            <q-card-actions align="right">
              <q-btn flat :label="$t('global.Cancel')" color="primary" v-close-popup />
              <q-btn flat :label="$t('global.Save')" @click="saveGroup()" color="primary" v-close-popup />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </q-card-section>
    </q-card>   

      </q-card-section>
    </q-card>   
  </div>
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'ExportTrack',
  data () {
    return {
      form: {
        SessionId: null,
      },
      newGroup: '',
      maintenanceGroupsOptions: [],
      maintenanceGroupSelected: null,
      title: 'General Editor',
      newOpend: false,
      selectedRowsGroup: [],
      columnsEvent: [
        {
          name: 'Group',required: true,label: this.$t('global.Name'), align: 'left',
          field: 'label',sortable: true
        }],
       pagination: {
        sortBy: null, // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 10 // current rows per page being displayed
      },
      editDialog: false,
      addDialog: false,
      editGroupName: ''  
    }
  },
  props: ['Entity'],
  methods: {
    loadMaintenanceGroups(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "MaintenanceGroupSelect"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.maintenanceGroupsOptions = response.data
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    },
    
    Init(){
      if(this.Entity.entity == 'MaintenanceGroup'){
        this.title = this.$t('global.MaintenanceGroups')
        this.loadMaintenanceGroups()
      }
    },
    editGroup(){
      debugger
      this.editGroupName  = this.selectedRowsGroup[0].label
      this.editDialog = true
    },
    updateGroup(){
      
      this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "EditGroup"
        this.form.MaintenanceGroupID = this.selectedRowsGroup[0].value
        this.form.MaintenanceGroupDescription = this.editGroupName
        this.form.TypeId = 1
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.GroupUpdated'), type: 'positive' })
                this.loadMaintenanceGroups()
                //this.selectedRowsGroup = []
                eventBus.$emit('Bus_MaintenanceGroupUpdate', null)
                this.editDialog = false
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
    },
    deleteGroup(){
      var self = this
      this.$q.dialog({
        title: this.selectedRowsGroup[0].label,
        message: this.$t('global.DeleteThisGroup') + '?',
        cancel: true, // takes i18n value, or String for "Cancel" button label
        
         
      })
      .onOk(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "DeleteMaintenanceGroup"
        this.form.MaintenanceGroupID = this.selectedRowsGroup[0].value
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.GroupDeleted'), type: 'positive' })
                this.loadMaintenanceGroups()
                this.selectedRowsGroup = []
                eventBus.$emit('Bus_MaintenanceGroupUpdate', null)
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
      })
      .onCancel(() => {
        //alert('Picked cancel')
      })
    },
    saveGroup(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "MaintenanceGroupInsert"
      this.form.NewGroupName = this.newGroup
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.NewGroupOk'), type: 'positive' })
                this.addDialog = false
                this.newGroup = ''
                this.loadMaintenanceGroups()
              }
              else{
                  this.$q.notify(this.$t('global.SomethingWrong'))
              }
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
      
    }

  },
  created () {
    this.Init()
  },
   watch: {
    Entity: function (newValue, oldValue) { 
      this.Init()
    },
   },
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style scoped>
  .space{
    margin-bottom: 10px
  }
  
</style>